import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-rules-ru',
  imports: [],
  templateUrl: './rules-ru.component.html',
  styleUrl: './rules-ru.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RulesRuComponent {
  scrollToSection(event: Event, sectionId: string): void {
    event.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
